import {pushFBEvent, pushGoogleTag} from './common';


export const PLANS = {
// fullPrice
    'fm-6month-71.76': {
        name: 'fm-6month-71.76',
        price: 71.76,
        periodPrice: 71.76,
        description: 'semi_annually',
        disclaimer: 'semi_annually',
        productId: '6 month - $71.76',
        duration: '6 month',
    },
    'fm-3month-59.99': {
        name: 'fm-3month-59.99',
        price: 59.99,
        periodPrice: 59.99,
        description: 'quarterly',
        disclaimer: 'quarterly',
        productId: '3 month - $59.99',
        duration: '3 month',
    },
    'fm-monthly-39.99': {
        name: 'fm-monthly-39.99',
        price: 39.99,
        periodPrice: 39.99,
        description: 'monthly',
        disclaimer: 'monthly',
        productId: '1 month - $39.99',
        duration: '1 month',
    },
// trial
    'fm-2month-intro7d-1.00-69.99': {
        name: 'fm-2month-intro7d-1.00-69.99',
        price: 69.99,
        periodPrice: 1,
        description: '1_week_trial',
        disclaimer: 'every_two_month',
        productId: '2 month - $69.99',
        duration: '2 month',
    },
    'fm-2month-intro7d-5.00-69.99': {
        name: 'fm-2month-intro7d-5.00-69.99',
        price: 69.99,
        periodPrice: 5,
        description: '1_week_trial',
        disclaimer: 'every_two_month',
        productId: '2 month - $69.99',
        duration: '2 month',
    },
    'fm-2month-intro7d-10.00-69.99': {
        name: 'fm-2month-intro7d-10.00-69.99',
        price: 69.99,
        periodPrice: 10,
        description: '1_week_trial',
        disclaimer: 'every_two_month',
        productId: '2 month - $69.99',
        duration: '2 month',
    },
    'fm-2month-intro7d-16.51-69.99': {
        name: 'fm-2month-intro7d-16.51-69.99',
        price: 69.99,
        periodPrice: 16.51,
        description: '1_week_trial',
        disclaimer: 'every_two_month',
        productId: '2 month - $69.99',
        duration: '2 month',
    },
// fdtrial
    'fm-monthly-intro14d-1.99-29.99': {
        name: 'fm-monthly-intro14d-1.99-29.99',
        price: 29.99,
        periodPrice: 1.99,
        description: 'two weeks trial',
        productId: '1 month - $29.99',
        duration: '1 month',
    },
};

const UPSELL = {
    name: 'fm-monthly-upsell-std',
    price: 9.99,
    quantity: 1
};

export const setMetrics = (plan, id, isUpsell = false, referer = '', eventId) => {
    const price = PLANS[plan].price;
    const upsellPrice = UPSELL.price;

    const items = isUpsell
        ? [
            {
                item_name: UPSELL.name,
                item_id: UPSELL.name,
                item_price: upsellPrice,
                quantity: 1,
                item_coupon: ''
            }
        ]
        : [
            {
                item_name: PLANS[plan].name,
                item_id: PLANS[plan].name,
                item_price: price,
                quantity: 1,
                item_coupon: ''
            }
        ];

    const gaData = {
        transaction_id: id,
        affiliation: 'Onboarding Store',
        value: isUpsell ? upsellPrice : price,
        tax: 0,
        shipping: 0,
        currency: 'USD',
        coupon: '',
        items
    };

    const setFbData = type => {
        return {
            value: type === 'upsell' ? upsellPrice : price,
            currency: 'USD',
            content_type: type,
            content_name: referer,
            subscription_sid: id,
        }
    };

    const fbData = setFbData('paid_subscription');
    const upsellFbData = setFbData('upsell');

    pushFBEvent(fbData,eventId);
    pushGoogleTag('purchase',gaData);
    if (isUpsell) pushFBEvent(upsellFbData,`${eventId}_upsell`);
};